import moduleBoot from 'app/unregistered';
import { render } from 'react-dom';
import 'css/app.less';
import React from 'react';
import NotFound from 'system/views/notFound/notFound';

(() => {
  window.about = window.about || {};
  window.about.PTX_DOCUMENTS = {
    uiVersion: '{{DEV_VERSION}}',
    gluVersion: null
  };

  const brandTheme = {
    spacing: {
      pageMargins: {
        margin: [0, 24],
        '@media screen and (min-width: 768px)': {
          margin: [0, 48]
        },
        '@media screen and (min-width: 960px)': {
          margin: [0, 60]
        },
        '@media screen and (min-width: 1852px)': {
          margin: [0, 'auto'],
          maxWidth: 1732
        }
      },
      pageMarginValues: {
        mobile: 24,
        tablet: 48,
        desktop: 60,
        desktopLarge: 'auto',
        desktopLargeMaxWidth: 1732
      },
      pageMarginBreakpoints: {
        tablet: 768,
        desktop: 960,
        desktopLarge: 1852
      }
    }
  };

  const config = {
    rootHtmlElementSelector: '.glu-content',
    root: '/ui/connect/',
    brandTheme: { ...brandTheme },
    skipUserFetch: true,
    interface: {
      triggerGlobalEvent: () => {
        // required empty function due to calls from One-PTX
      },
      unauthenticated: () => {
        // required empty function due to calls from One-PTX
      },
      forbidden: () => {
        // required empty function due to calls from One-PTX
      },
      onError: () => {
        // required empty function due to calls from One-PTX
      },
      notFound: () => {
        render((
          <NotFound />
        ), document.querySelector(config.rootHtmlElementSelector));
      },
      serverError: () => {
        // required empty function due to calls from One-PTX
      },
      registerGlobalEvents: () => {
        // required empty function due to calls from One-PTX
      },
      updateToken: () => Promise.resolve()
    }
  };

  const gluContent = window.document.getElementById('glu-content');
  const oldBrowser = window.document.getElementById('old-browser');
  const compatibilityView = window.document.getElementById('compatibility-view');
  const pathname = !window.location.hash ? window.location.pathname : window.location.hash;
  const documentRegexp = new RegExp(`${config.root}[/]?[#]?document`, 'ig');
  const doc = document.documentElement;
  const Bottomline = window.Bottomline || {
    browser: {}
  };

  // Prevent access from very old browsers
  if (
    (Bottomline.browser.chrome && Bottomline.browser.version < 20)
    || (Bottomline.browser.firefox && Bottomline.browser.version < 12)
    || (Bottomline.browser.msie && Bottomline.browser.version < 10)
  ) {
    if (documentRegexp.test(pathname)) {
      oldBrowser.style.cssText = 'display:none !important';
      compatibilityView.style.cssText = 'display:none !important';
      return Bottomline.runUnregisteredModule(config);
    }
    gluContent.style.display = 'none';
    compatibilityView.style.cssText = 'display:none !important';
    oldBrowser.style.display = 'block';
    return false;
  }

  // check compatibility mode for IE
  if (Bottomline.browser.isIECompatibilityMode()) {
    gluContent.style.display = 'none';
    oldBrowser.style.cssText = 'display:none !important';
    compatibilityView.style.display = 'block';
    return false;
  }

  // TODO: remove this after major glu update to GLU 1.8
  // check if browser is IE10 and add specific class to apply only IE10 specific styles.
  if (Bottomline.browser.msie && Bottomline.browser.version === 10) {
    doc.className += ' lt-ie11';
  }

  return moduleBoot.start(config);
})();
